import { defineStore } from 'pinia'
import axiosInstance from "@/services/axiosInstance";
import router from "@/router";

export const useAuthStore = defineStore('auth', {
    state: () => {
        return {
            isLoading: false,
            currentUser: null,
            isAuthenticated: false,
            token: localStorage.getItem('token') || null
        }
    },
    actions: {
        async login(credentials) {
            this.isLoading = true
            try {
                const response = await axiosInstance.post('/login', credentials)
                const { token, user } = response.data

                this.token = token
                this.currentUser = user
                this.isAuthenticated = true

                localStorage.setItem('token', token)

                await router.push("/");

                return { success: true }
            } catch (error) {
                this.logout()
                return { success: false, error: error.response?.data?.message || 'Ошибка входа' }
            } finally {
                this.isLoading = false
            }
        },

        async fetchCurrentUser() {
            if (!this.token) {
                this.logout()
                return false
            }

            this.isLoading = true
            try {
                const response = await axiosInstance.get('/users/current')
                this.currentUser = response.data
                this.isAuthenticated = true
                return true
            } catch (error) {
                if (error.response?.status === 401) {
                    this.logout()
                }
                return false
            } finally {
                this.isLoading = false
            }
        },

        logout() {
            this.currentUser = null
            this.token = null
            this.isAuthenticated = false

            localStorage.removeItem('token')
            router.push('/login')
        },

        async checkAuth() {
            if (this.token && !this.currentUser) {
                return await this.fetchCurrentUser()
            }
            return this.isAuthenticated
        }
    },

    persist: {
        key: 'auth-store',
        storage: localStorage,
        // Можно указать какие поля сохранять
        paths: ['currentUser', 'token', 'isAuthenticated']
    }
})